import React, { ReactNode } from 'react';

import { ReadAboutButton as StyledReadAboutButton, Label } from './wrappers';
import { ChevronRightIcon } from '../Icon';

interface IReadAboutButton {
  children: ReactNode;
  onClick?: () => void;
  isPanelExpanded?: boolean;
}

const ReadAboutButton = ({ children, onClick, isPanelExpanded }: IReadAboutButton) => {
  const title = children?.toString();
  const ariaLabel = isPanelExpanded ? `Stäng panel för ${title}` : `Öppna panel för ${title}`;
  return (
    <StyledReadAboutButton
      aria-label={ariaLabel}
      aria-haspopup="dialog"
      aria-expanded={isPanelExpanded}
      onClick={onClick}>
      <Label>{children}</Label>
      <ChevronRightIcon strokeWidth="2" />
    </StyledReadAboutButton>
  );
};

export default ReadAboutButton;
